import { UPDATE_WIDGET_HASH } from "../../actions/DashboardDesigner/actionContants";

const widgetHash = (state = {}, action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type:
		 *  widgetHash:
		 * }
		 */
		case UPDATE_WIDGET_HASH:
			return action.widgetHash;
		default:
			return state;
	}
};

export default widgetHash;
